module.exports = __webpack_public_path__ + "775bf85d4ef742d2ab7332b18092b676.png";